/**
 * The new-project draft: {name, slug} survives the round trip through
 * GitHub's install/authorize page, which leaves the SPA entirely (same
 * reason SsoCallback/sso-state.ts uses sessionStorage rather than React
 * state or a URL param for the SSO round trip). Real mode only, the mock
 * onboarding flow carries its app name in the `?app=` query param instead
 * (lib/mock/onboarding.ts), unchanged.
 */
const DRAFT_KEY = 'sv-cloud-new-project';

export type CodeHost = 'svgit' | 'github';

export interface NewProjectDraft {
  name: string;
  slug: string;
  /** Chosen on /new/code. Absent until then. */
  codeHost?: CodeHost;
}

export function writeDraft(draft: NewProjectDraft): void {
  sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
}

export function readDraft(): NewProjectDraft | null {
  const raw = sessionStorage.getItem(DRAFT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<NewProjectDraft>;
    if (typeof parsed.name !== 'string' || typeof parsed.slug !== 'string') return null;
    const codeHost = parsed.codeHost === 'svgit' || parsed.codeHost === 'github' ? parsed.codeHost : undefined;
    return { name: parsed.name, slug: parsed.slug, ...(codeHost ? { codeHost } : {}) };
  } catch {
    return null;
  }
}

export function clearDraft(): void {
  sessionStorage.removeItem(DRAFT_KEY);
}
